import useApiCall from "../hooks/CancellableApiCall";
import {
    Alert, Box,
    Button,
    FormControl,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Snackbar,
    Stack,
    Typography,
    TextField
} from "@mui/material";
import {LoadingContent} from "../components/LoadingContent";
import React, {useCallback, useState} from "react";
import {AwardResponse} from "../data/AwardResponse";
import {MuiFileInput} from "mui-file-input";

interface EditAwardPageProps {
    awards: AwardResponse[],
    refresh: () => void,
}

type alertType = "success" | "error" | "info"

function EditAwardPageContent(props: EditAwardPageProps) {
    const [awardIdx, setAwardIdx] = useState<number | null>(null)
    const award = awardIdx != null ? props.awards.at(awardIdx) : null
    const [showAlert, setShowAlert] = useState(false)
    const [alertType, setAlertType] = useState<alertType>("success")
    const [alertText, setAlertText] = useState("")
    const [name, setName] = useState("")
    const [file, setFile] = useState<File | null>(null)

    const setAlert = useCallback((type: alertType, text: string) => {
        setAlertType(type)
        setAlertText(text)
        setShowAlert(true)
    }, [setAlertType, setAlertText, setShowAlert])

    const editAward = (awardId: number, name: string, image: File) => {
        const formData = new FormData()
        formData.append("image", image)
        formData.append("name", name)
        const request = new XMLHttpRequest()
        request.onreadystatechange = (_) => {
            if (request.readyState === 4 && request.status === 200) {
                setAlert("success", `Updated award ${name}!`)
                setFile(null)
                setName("")
            }
        }
        request.onerror = (_) => {
            setAlert("error", "Failed to update award")
        }
        request.open("PATCH", `/api/awards/${awardId}`)
        request.send(formData)
    }

    return <Box sx={{width:"100%"}}>
        <Typography variant={"h6"} gutterBottom>Edit Award</Typography>
        <Paper variant={"outlined"} style={{
            width:"100%",
            padding: "16px"
        }}>
            <Stack spacing={1} sx={{}}>
                <FormControl>
                    <InputLabel id="award-select-label">Select Award</InputLabel>
                    <Select id="award-select" value={awardIdx} label="Select-Award" onChange={(event) => {
                        setAwardIdx(event.target.value as number)
                    }}>
                        {props.awards.map((award, idx) =>
                            <MenuItem key={award.name} value={idx}>{award.name}</MenuItem>
                        )}
                    </Select>

                    <TextField id="award-name" label="Award Name (Leave Blank to keep the same)" variant="outlined" onChange={(e) => setName(e.target.value)}/>

                    <MuiFileInput inputProps={{accept: ".jpg, .png"}} value={file} onChange={setFile}/>
                </FormControl>
                <Button disabled={!award} variant="contained" color={"error"} onClick={() => {
                    if (award && file) {
                        editAward(award.id, name.trim() ? name : award.name, file)
                    }
                }}>
                    Edit Award (THERE IS NO CONFIRMATION BE REALLY CAREFUL!!!)
                </Button>
                <Snackbar open={showAlert} autoHideDuration={5000} onClose={() => setShowAlert(false)}>
                    <Alert severity={alertType} onClose={() => setShowAlert(false)} sx={{width: "100%"}} variant="filled">
                        {alertText}
                    </Alert>
                </Snackbar>
            </Stack>
        </Paper>
    </Box>
}

export const EditAwardPage = () => {
    const loadAwards = useApiCall<AwardResponse[]>({
        initialUrl: "/api/awards"
    })

    return (
        <>
            <LoadingContent isLoading={loadAwards.isLoading}>
                <Stack spacing={{xs: 2, sm: 4}} direction="row" useFlexGap flexWrap="wrap">
                    <EditAwardPageContent awards={loadAwards.data!!} refresh={loadAwards.refresh}/>
                </Stack>
            </LoadingContent>
        </>
    )
}